import { StyledTooltip } from './Css'

const Tooltip = ({ children, title, ...rest }: any) => (
  <StyledTooltip title={title} arrow {...rest}>
    {children}
  </StyledTooltip>
)

export default Tooltip
